/**
 * @file
 * @copyright  2017 Subscribe-HR
 */

import Enum from './Enum';

/**
 * Subscribe-HR entity email field
 */
export default class EnumMulti extends Enum {
}



// WEBPACK FOOTER //
// ./src/client/common/js-subscribe-sdk/lib/Fields/EnumMulti.js